import { useEffect, useMemo, useState } from 'react'
import axios from 'axios'
import DataTableShell from '../../../../Components/table/DataTableShell'
import TableToolbar from '../../../../Components/table/TableToolbar'
import TableSearch from '../../../../Components/table/TableSearch'
import { TableEmptyRow, TableIdCell, TableSkeletonRows } from '../../../../Components/table/TableCells'
import useClientTable from '../../../../Components/table/useClientTable'

const TABLE_HEAD = [ "Order ID", "Tracking ID", "Fulfillment", "SKU", "Item Total"]

const ManageOrdersTable = ({ batchId }) => {

    const [orderMap, setOrderMap] = useState({});
    const [flattenedBatchList, setFlattenedBatchList] = useState([])

    useEffect(() => {
        const fetchBatchData = async () => {
            try {
                const [nexResponse, acResponse] = await Promise.all([
                    axios.get(`/api/refund-audits/get/${batchId}`),
                    axios.get(`https://api-central.outdoorequippedservice.com/api/v1/warehouse-refunds/audits/batch-content/${batchId}`)
                ])
    
                if (nexResponse.data.message || acResponse.data.message) {
                    console.log("Cannot get batches")
                } else {
                    const nexData = nexResponse.data.result.batchContent
                    const acData = acResponse.data[0].batchDetails
    
                    const tempBatchList = []

                    const tempOrderMap = {}
                    nexData.forEach((batch, index) => {
                        tempOrderMap[batch.orderId] = index
                    })
                    setOrderMap(tempOrderMap)
                    
                    nexData.forEach(batch => {
                        const acBatch = acData?.find(item => item._id === batch._id)
                        if (acBatch && acBatch?.manageOrdersData.length > 0) {
                            acBatch?.manageOrdersData.forEach((order, orderIndex) => {
                                order.PackageItems.forEach((pack, packageIndex) =>{
                                    order.OrderItems.forEach((cost, costIndex) =>{

                                        const orderId = batch?.orderId || '....'
                                        const trackId = order?.TrackingId || '....'
                                        const fulfill = order?.Fulfillment || '....'
                                        const sku = pack?.SellerSKU || '....'

                                        const packageItemSKU = pack?.SellerSKU
                                        const packageOrderId = pack?.OrderItemId
    
                                        const orderItemSKU = cost?.SellerSKU
                                        const orderItemsId = cost?.OrderItemId
    
                                        const costChecker = (packageItemSKU === orderItemSKU) && (packageOrderId === orderItemsId)
                                        const itemTotal = costChecker ?  cost?.ItemCost?.Total?.Amount : 'not matched'

                                        const rowKey = `${batch._id}-${orderIndex}-${packageIndex}-${costIndex}`
                                        tempBatchList.push({ rowKey, orderId, trackId, fulfill, sku, itemTotal });
                                    })
                                })
                            })
                        }
                    })
                    setFlattenedBatchList(tempBatchList)
                }
            } catch (error) {
                console.error('Error:', error)
            }
        }
        fetchBatchData()
    }, [batchId])

    const flattenedBatchArray = useMemo(
        () => [...flattenedBatchList].sort((a, b) => orderMap[a.orderId] - orderMap[b.orderId]),
        [flattenedBatchList, orderMap]
    );

    const batchesPerPage = 15
    const {
        searchTerm,
        handleSearch,
        currentPage,
        setCurrentPage,
        pageItems: batchData,
        totalPages,
        totalFiltered,
    } = useClientTable({
        data: flattenedBatchArray,
        pageSize: batchesPerPage,
        filterFn: (item, query) =>
            !query ||
            item.orderId?.toString().toLowerCase().includes(query) ||
            item.trackId?.toString().toLowerCase().includes(query) ||
            item.sku?.toLowerCase().includes(query),
    })

    return (
        <DataTableShell
            minWidth="860px"
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
            toolbar={
                <TableToolbar
                    kicker="Refund audit"
                    title="Manage orders"
                    subtitle={`${totalFiltered} matching order items`}
                    actions={
                        <TableSearch
                            id="manage-orders-search"
                            value={searchTerm}
                            onChange={handleSearch}
                            placeholder="Search order, tracking, or SKU"
                        />
                    }
                />
            }
        >
                    <thead>
                        <tr>
                            {TABLE_HEAD.map((head) => (
                                <th key={head} className={head === 'Order ID' ? 'nx-sticky-col' : ''}>
                                    {head}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {flattenedBatchArray.length <= 0 ?
                            <TableSkeletonRows columns={TABLE_HEAD.length} rows={15} /> :
                            batchData.length === 0 ?
                            <TableEmptyRow columns={TABLE_HEAD.length} title="No order items found" description="Try a different order, tracking ID, or SKU." /> :
                                (batchData.map((item) => (
                                    <tr key={item.rowKey}>
                                        <td className="nx-sticky-col">
                                            <TableIdCell>{item.orderId}</TableIdCell>
                                        </td>
                                        <td><TableIdCell>{item.trackId}</TableIdCell></td>
                                        <td>{item.fulfill}</td>
                                        <td>{item.sku}</td>
                                        <td className="nx-cell-num">{item.itemTotal}</td>
                                    </tr>
                                )))         
                            }
                    </tbody>
        </DataTableShell>
    )
}

export default ManageOrdersTable
